import { IS_DEV } from "@/data/constants";

export const PAYMENT_V2_BASE_URL =
  import.meta.env.VITE_PAYMENT_API ||
  (IS_DEV
    ? "https://api.aftershoot.co/payments"
    : "https://api.aftershoot.co/payments");

export const PAYMENT_V2_ENDPOINT_V1 = `${PAYMENT_V2_BASE_URL}/v1`;
export const PAYMENT_V2_ENDPOINT_V2 = `${PAYMENT_V2_BASE_URL}/v2`;

export enum PLAN_INTENT {
  BUY = "buy",
  TRIAL = "trial",
}
